<template>
  <section>
    <div class="c-modal" :style="{display: show ? 'block' : 'none', 'z-index': 302}">
      <div class="c-modal__dialog c-modal__dialog--center">
          <!-- Modal content -->
          <div class="c-modal__content">
            <div class="c-modal__title">
              特定商取引法に基づく表記
            </div>
            <div class="c-modal__body commercial-law">
              <dl>
                <dt>販売事業者</dt>
                <dd>{{tenant.salesDistributor}}</dd>
              </dl>
              <dl>
                <dt>責任者氏名</dt>
                <dd>{{tenant.salesRepresentative}}</dd>
              </dl>
              <dl>
                <dt>所在地</dt>
                <dd>{{tenant.distributorLocation}}</dd>
              </dl>
              <dl>
                <dt>お問い合わせ先</dt>
                <dd>{{tenant.distributorContact}}</dd>
              </dl>
              <dl>
                <dt>販売価格</dt>
                <dd>
                  本アプリご注文ページに表示する価格<br />
                  ※本表示価格は本体価格に消費税額を加えた合計金額（税込価格）となります。
                </dd>
              </dl>
              <dl>
                <dt>商品代金以外に必要な費用</dt>
                <dd>{{tenant.costExcludes}}</dd>
              </dl>
              <dl>
                <dt>代金の支払い方法、時期</dt>
                <dd>
                  【お支払い方法】クレジットカード決済（イオンカード、ＶＩＳＡ、Ｍａｓｔｅｒ）<br />
                  【お支払い時期】本アプリでのご注文完了時に決済となり、お支払い時期はご利用のクレジットカード会社の会員規約に基づきます。
                </dd>
              </dl>
              <dl>
                <dt>商品等の引き渡し時期</dt>
                <dd>ご注文完了時に指定した場所、指定した日時でのお引き渡しとなります。</dd>
              </dl>
              <dl>
                <dt>返品の対応</dt>
                <dd v-html="nl2br(tenant.returnHandling)"></dd>
              </dl>
              <dl>
                <dt>注文のキャンセル</dt>
                <dd>
                  本アプリに表示されるステータスが「注文完了」時はキャンセルが可能です。<br />
                  商品準備が開始され、ステータスが「商品準備中」となって以降はキャンセルすることができません。
                </dd>
              </dl>
              <dl>
                <dt>数量制限のある商品</dt>
                <dd>販売条件がある商品は、本アプリご注文ページの商品詳細に記載いたします。</dd>
              </dl>
              <dl>
                <dt>その他の注意点</dt>
                <dd>
                  指定した日時にお引き渡しできない場合や商品在庫が切れている場合、その他必要と判断した場合には、<br />
                  モバイルオーダー利用開始時にご登録いただいた電話番号にご連絡させていただくことがございます。
                </dd>
              </dl>
            </div>
            <div class="c-modal__buttons">
              <a href="javascript:void(0)" @click.prevent="closeModal" class="c-btn-close">
                <img src="/assets/images/icon/icon-close-black.svg" alt="" />閉じる
              </a>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { eventBus, Common } from "../common/common";

export default Vue.extend({
  name: 'commercial-law-popup',
  props: ['tenant', 'show', 'closeModal'],
  data() {
    return {
      in_call: true
    }
  },
  created(){
    eventBus.$on("answerCall", function(){
      this.in_call = true;
    });
    eventBus.$on("endCall", function(){
      this.in_call = false;
    })
  },
  components: {
  },
  methods: {
    nl2br(value) {
      return value?.replace(/\n/gi, "<br/>\n");
    }
  }
})
</script>